//import logo from './logo.svg';
import './App.css';
import './Header.css';
import './Games.css';
import './Footer.css';
import './Join.css';
import './FAQ.css';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useState } from 'react';
import Collapse from 'react-bootstrap/Collapse';
var open
function App(args) {

  return (
    <div className='App'>
      <header>
        <Navbar expand="lg" className='Header-nav'>
          <Container>
            <Navbar.Brand href="#home"><img alt="TLBMilSim logo" className="d-inline-block align-top Header-logo" src="https://cdn.tga.fyi/tlb/logos/TLBLogo.png"></img></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" className='Header-toggler'/>
            <Navbar.Collapse id="basic-navbar-nav" className='justify-content-end'>
              <Nav.Link className='Header-button' href="/apply">Apply Today</Nav.Link>
              <Nav.Link className='Header-button' href="https://discord.gg/2CCmuej">Discord</Nav.Link>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <Container>
          <Row>
            <Col className='Header-mission-statement'>
              <h1>THE LOST BETALLION</h1>
              <p>REALISM WHERE IT MATTERS</p>
            </Col>
          </Row>
        </Container>
        <div className='Header-fade'></div>
      </header>
      <Container className='Games'>
        <p className='Games-para'>We are a group of enthusiastic Arma 3 players who share a passion for military simulation and tactical gameplay. Our Operations take place in diverse and challenging environments, ranging from Norway and Afghanistan to other thrilling locations. Our mission variety includes both handcrafted Zeus-made missions and dynamic experiences through auto-generated missions like Dynamic Recon Ops and Liberation.</p>
      </Container>
      <Container className='Games-three-images'>
        <Row>
          <Col className='Games-images-1'>
          </Col>
          <Col className='Games-images-2'>
          </Col>
          <Col className='Games-images-3'>
          </Col>
        </Row>
      </Container>
      <Container className='Games'>
        <p className='Games-para'>We are a group of enthusiastic Arma 3 players who share a passion for military simulation and tactical gameplay. Our Operations take place in diverse and challenging environments, ranging from Norway and Afghanistan to other thrilling locations. Our mission variety includes both handcrafted Zeus-made missions and dynamic experiences through auto-generated missions like Dynamic Recon Ops and Liberation.</p>
        <Container className='Games-who'>
          <Row className='Games-row'>
            <Col className='Games-image Games-blank-1'>
            </Col>
            <Col className='Games-Align-Right Games-Info Games-Info-1'>
              <h1><b>Who are we</b></h1>
              <hr />
              <p>At TLB, we understand that real-life commitments such as work or school may sometimes take precedence. We are a flexible community, and we only require our members to attend at least one operation per month to be considered active. This approach ensures that players can balance their real-life responsibilities while still being part of an engaging gaming experience.</p>
            </Col>
          </Row>
        </Container>
        <Container className='Games-how'>
          <Row className='Games-row'>
            <Col className='Games-Order-First Games-Info Games-Info-2'>
              <h1><b>How to join us</b></h1>
              <hr />
              <p>Joining TLB is a straightforward process. After expressing your interest, you’ll undergo a short interview to get to know you better and understand your expectations. Once you’ve successfully completed the interview, we’ll provide you with a short basic training to familiarize you with our milsim playstyle and tactics. This training ensures that all members are on the same page and ready to tackle challenges as a cohesive unit.</p>
            </Col>
            <Col className='Games-image Games-Order-Last'>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container className='Join'>
        <Row>
          <Col xs={12} md={8}>
            <hr />
            <h1>Joining TLB is a straightforward process</h1>
            <p>As you continue your journey with TLB, you’ll have the opportunity to rank up within our structured ranking system. This system acknowledges your dedication, skill, and contribution to the unit, allowing you to take on more significant roles and responsibilities if you wish.</p>
          </Col>
          <Col xs={6} md={4} className='Join-button'>
            <a href="/apply" className='btn btn-warning'>Apply Today</a>
          </Col>
          <Col className='Join-button-mobile'>
            <a href="/apply" className='btn btn-warning'>Apply Today</a>
          </Col>
        </Row>
      </Container>
      <Container className='FAQ'>
        <h1>F.A.Q.</h1>
        <div className='FAQ-item'>
          <a class="btn FAQ-btn" data-bs-toggle="collapse" href="#eng-ops" role="button" aria-expanded="false" aria-controls="eng-ops">Engaging Operations</a>
          <div class="collapse multi-collapse" id="eng-ops">
            <div className='FAQ-body'>
              <p>Our handcrafted and auto-generated missions ensure a wide variety of scenarios, keeping each operation fresh and exciting. We host one main mission every week on Friday at 19:00 CEST, providing you with a regular and thrilling experience to look forward to.</p>
            </div>
          </div>
        </div>

        <div className='FAQ-item'>
          <a class="btn FAQ-btn" data-bs-toggle="collapse" href="#Flexibility" role="button" aria-expanded="false" aria-controls="Flexibility">Flexibility</a>
          <div class="collapse multi-collapse" id="Flexibility">
            <div className='FAQ-body'>
              <p>We understand that life can be busy, so we offer a low attendance requirement, allowing you to balance real-life commitments and gaming.</p>
            </div>
          </div>
        </div>

        <div className='FAQ-item'>
          <a class="btn FAQ-btn" data-bs-toggle="collapse" href="#fren" role="button" aria-expanded="false" aria-controls="fren">Friendly Community</a>
          <div class="collapse multi-collapse" id="fren">
            <div className='FAQ-body'>
              <p>TLB is a welcoming and supportive group where you can forge lasting friendships with like-minded players.</p>
            </div>
          </div>
        </div>

        <div className='FAQ-item'>
          <a class="btn FAQ-btn" data-bs-toggle="collapse" href="#skill" role="button" aria-expanded="false" aria-controls="skill">Skill Development</a>
          <div class="collapse multi-collapse" id="skill">
            <div className='FAQ-body'>
              <p>Whether you’re a seasoned ArmA3 veteran or a newcomer, our training sessions and cooperative gameplay will enhance your tactical skills.</p>
            </div>
          </div>
        </div>

        <div className='FAQ-item'>
          <a class="btn FAQ-btn" data-bs-toggle="collapse" href="#opp" role="button" aria-expanded="false" aria-controls="opp">Leadership Opportunities</a>
          <div class="collapse multi-collapse" id="opp">
            <div className='FAQ-body'>
              <p>As you progress within the unit, you’ll have the chance to take on leadership roles, contributing to the growth and success of TLB.</p>
            </div>
          </div>
        </div>

      </Container>
      <Container className='Footer'>
        <Row>
          <Col>
            <p>Designed and created by <a href="https://lawrencetech.uk" className='Footer-credit'><b>Lawrence Tech</b></a>, made in the UK.</p>
            <p>Copyright (c) {(new Date().getFullYear())} TheGoldApple & Lawrence Tech All Rights Reserved.</p>
            <p>ArmA and other associated brands are trademarks of Bohemia Interactive, and are not affiliated with TLB or TGA.</p>
            <hr />
            <Row className='Footer-Logos'>
              <Col className="Footer-Logos">
                <img src="https://cdn.tga.fyi/tlb/logos/Bandge-and-TLB.png" width="256px"/>
              </Col>
              <Col className="Footer-Logos">
                <img src="https://cdn.tga.fyi/tga/logos/TheGoldApple_Long.png" width="256px"/>
              </Col>
            </Row>
          </Col>
          <Col className='Footer-Links'>
            <h4>Links</h4>
            <div>
              <ul>
                <li><a className='Footer-Link' href="terms">Terms and Conditions</a></li>
                <li><a className='Footer-Link' href="#about">About Us</a></li>
                <li><a className='Footer-Link' href="#styleguide">Style Guide</a></li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default App;
